(function () {
	'use strict';

	angular.module('dcApp').component('projectVersionUniqueness', {
		bindings: {
			version: '=',
			uuid: '=',
			invalid: '=?',
		},
		templateUrl:
			'./src/components/directives/project/project-version-uniqueness/project-version-uniqueness.html',
		controller: [
			'$log',
			'$scope',
			'ProjectService',
			function ($log, $scope, ProjectService) {
				var vm = this;
				vm.isVersionNotUnique = false;
				vm.isVersionFormatInvalid = false;
				vm.isVersionTooLong = false;
				// Mirrors the back-end project version validator
				vm.versionPattern = /^[0-9]{1,18}(\.[0-9]{1,18})*$/;

				vm.versionMaxLength = 32;

				// Watch for changes in both version and uuid to trigger the check
				$scope.$watchGroup(
					['vm.version', 'vm.uuid'],
					function ([version, uuid]) {
						vm.isVersionFormatInvalid =
							!!version && !vm.versionPattern.test(version);
						vm.isVersionTooLong =
							!!version && version.length > vm.versionMaxLength;

						if (vm.isVersionFormatInvalid || vm.isVersionTooLong) {
							// A malformed version can never be a valid candidate, skip the round trip
							vm.isVersionNotUnique = false;
							vm.invalid = true;
							$scope.$emit('projectVersion:validity:unique', false);
							return;
						}

						// We only perform the check if both a version and a UUID are present
						if (version && uuid) {
							ProjectService.isVersionUnique(uuid, version)
								.then((response) => {
									vm.isVersionNotUnique = !response.data;
									vm.invalid = vm.isVersionNotUnique;
									$scope.$emit('projectVersion:validity:unique', response.data);
								})
								.catch((error) => {
									$log.error(error);
									vm.isVersionNotUnique = true;
									vm.invalid = true;
									$scope.$emit('projectVersion:validity:unique', false);
								});
						} else {
							// If no version or UUID, the field is considered valid (no uniqueness conflict)
							vm.isVersionNotUnique = false;
							vm.invalid = false;
							$scope.$emit('projectVersion:validity:unique', true);
						}
					},
					true
				);
			},
		],
		controllerAs: 'vm',
	});
})();
